import React, { Component } from 'react';
import firebase from '../../helper/firebase';
import {
	Button,
	Card,
	CardActions,
	CircularProgress,
	Divider
} from 'material-ui';

import Head from '../../components/Head';
import SkeletonSectionTitle from '../../components/SkeletonSectionTitle';
import SectionTitle from '../../components/SectionTitle';
import SkeletonCard from '../../components/SkeletonCard';
import JobCardHeader from '../../components/JobCardHeader';
import LoggedOutCard from '../../components/LoggedOutCard';
import UnauthorizedText from '../../components/UnauthorizedText';
import ApplicantCardHeader from '../../components/ApplicantCardHeader';
import JobCardReferees from '../../components/JobCardReferees';

import { Title } from '../../helper/consts';
const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	}
};
export default class Payout extends Component {
	constructor() {
		super();

		this.state = {
			commissions: {},
			users: {},
			offers: {},
			loading: true
		};
	}
	//get job using redux
	componentDidMount() {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.state = {
					commissions: {},
					users: {},
					offers: {},
					loading: true
				};
				this.props.actions.getJob(this.props.match.params.jid);
				this.getInfo();
			} else {
				firebase
					.database()
					.ref(`commissions/${this.props.match.params.jid}`)
					.off();
				this.state = {
					commissions: {},
					users: {},
					offers: {},
					loading: true
				};
			}
		});
	}

	componentWillUnmount() {
		firebase
			.database()
			.ref(`commissions/${this.props.match.params.jid}`)
			.off();
	}

	noInfo = () => {
		this.setState({ commissions: {}, users: {}, loading: false });
		this.props.actions.setSnack(true, `Error: Please try again.`);
	};

	//subscribe to commissions/jid
	getInfo = () => {
		const ref = firebase.database().ref();
		ref
			.child(`commissions/${this.props.match.params.jid}`)
			.on('value', commissionsSnap => {
				if (!commissionsSnap.val()) {
					this.noInfo();
				} else {
					this.setState({ commissions: commissionsSnap.val() });
					this.getUsers(commissionsSnap.val());
				}
			});
	};
	//for each commission get user from users/uid
	getUsers = commissions => {
		let promises = [];
		let { users } = this.state;
		const ref = firebase.database().ref();
		const uids = Object.keys(commissions);
		let counter = uids.length;
		uids.forEach(uid => {
			if (!users[uid]) {
				console.log('getting new users');
				const userPromise = ref
					.child(`users/${uid}`)
					.once('value')
					.then(userSnap => {
						users[uid] = userSnap.val();
						this.setState({ users });
					})
					.catch(err =>
						this.props.actions.setSnack(true, 'Error: Please try again.')
					);
				promises.push(userPromise);
			}
			counter--;
			if (counter === 0) {
				Promise.all(promises).then(() => {
					this.setState({ loading: false });
				});
			}
		});
	};

	updateStatus = (status, uid) => {
		const ref = firebase.database().ref();
		let promises = [];
		const commissionPromise = ref
			.child(`commissions/${this.props.match.params.jid}/${uid}`)
			.update({ status });
		promises.push(commissionPromise);
		const userPromise = ref
			.child(`myCommissions/${uid}/${this.props.match.params.jid}`)
			.update({ status });
		promises.push(userPromise);
		Promise.all(promises).catch(err => {
			console.log(err);
			this.props.actions.setSnack(true, 'Error: Please try again.');
		});
	};

	renderUsers = () => {
		let html = [];
		const { users, commissions, offers } = this.state;
		Object.keys(commissions).forEach(uid => {
			let card = (
				<Card className="card">
					<ApplicantCardHeader applicant={users[uid]} />
					<Divider light />
					{!!offers[uid] && (
						<JobCardReferees
							shareCount="hide"
							photoURL={this.props.auth.photoURL}
							users={offers[uid].users}
							uid={this.props.uid}
							displayName={this.props.auth.displayName}
						/>
					)}
					{!!offers[uid] && <Divider light />}
					<CardActions className="cardActions">
						<Button
							raised
							onClick={() => {
								this.updateStatus('declined', uid);
							}}
							disabled={commissions[uid].status === 'declined'}
						>
							{'Decline'}
						</Button>
						<Button
							raised
							onClick={() => {
								this.updateStatus('requested', uid);
							}}
							disabled={commissions[uid].status === 'requested'}
						>{`$${commissions[uid].commission} Pending`}</Button>
						<Button
							raised
							onClick={() => {
								this.updateStatus('paid', uid);
							}}
							disabled={commissions[uid].status === 'paid'}
						>{`$${commissions[uid].commission} Paid`}</Button>
					</CardActions>
				</Card>
			);
			html.push(card);
		});
		return html;
	};

	render() {
		return (
			<React.Fragment>
				<Head title={`Payout | ${Title}`} />
				<div id={this.props.loggedIn ? 'loggedInBody' : null} className="body">
					{this.props.authLoading && (
						<CircularProgress style={style.loading} size={75} />
					)}

					{this.props.loggedIn &&
						this.props.admin &&
						!this.props.jobs[this.props.match.params.jid] && (
							<SkeletonSectionTitle />
						)}
					{this.props.loggedIn &&
						this.props.admin &&
						!!this.props.jobs[this.props.match.params.jid] && (
							<SectionTitle title="Job" />
						)}

					{this.props.loggedIn &&
						this.props.admin &&
						!this.props.jobs[this.props.match.params.jid] && (
							<SkeletonCard header={true} />
						)}
					{this.props.loggedIn &&
						this.props.admin &&
						!!this.props.jobs[this.props.match.params.jid] && (
							<Card className="card">
								<JobCardHeader
									job={this.props.jobs[this.props.match.params.jid]}
								/>
							</Card>
						)}

					{this.props.loggedIn &&
						this.props.admin &&
						this.state.loading && <SkeletonSectionTitle />}
					{this.props.loggedIn &&
						this.props.admin &&
						!this.state.loading && <SectionTitle title="Payouts" />}

					{this.props.loggedIn &&
						this.props.admin &&
						this.state.loading && <SkeletonCard header={true} />}
					{this.props.loggedIn &&
						this.props.admin &&
						!this.state.loading &&
						this.renderUsers()}

					{!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}

					{!this.props.authLoading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						!this.props.admin && (
							<div className="unauthorizedTextContainer">
								<UnauthorizedText
									text="Unauthorized"
									subText="Access is limited"
								/>
							</div>
						)}
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Payout/Payout.js